import { Typography } from "@mui/material";
import React, { useState } from "react";
import { disclaimerData, stepOneData } from "../stepsData";
import { paragraphStyleOL } from "../../../../calculatorStyleData";
import tongueOut from "../../../../../Assets/Images/tongue-out.webp";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StepOne = () => {
  // State to track visibility of the div
  const [isVisible, setIsVisible] = useState(false);
  // handling visibility of need help container

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
  return (
    <>
      <div className="mt-3">
        <div>
          <Typography
            sx={{
              fontFamily: "'Archivo', sans-serif",
              fontSize: "16px",
              letterSpacing: "normal",
              lineHeight: "24px",
            }}
          >
            Gold loans are a quick and convenient way to meet your financial
            needs by leveraging your gold assets. Whether it's for a medical
            emergency, education, or business purposes, knowing your monthly
            repayment in advance is crucial for effective financial planning.
            Our Gold Loan EMI Calculator is designed to provide you with an
            accurate estimate of your monthly EMIs based on the loan amount,
            interest rate, and tenure. By using this tool, you can plan your
            repayments confidently, ensuring a smooth borrowing experience.
          </Typography>
        </div>
        <div id="list-data">
          <div className=" d-flex flex-column mt-3 ">
            {/* heading */}
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "32px",
                letterSpacing: "0.08px",
                textAlign: "start",
                fontFamily: "'Archivo', sans-serif",
                color: "#1F1F1F",
                fontWeight: 700,
              }}
            >
              {stepOneData[0].heading}
            </Typography>
          </div>
          <div id="list_data_content" className=" d-flex flex-column mt-2">
            <ol style={paragraphStyleOL}>
              {stepOneData[0].infoList &&
                stepOneData[0].infoList.map((item, index) => (
                  <li className="mt-2">
                    {" "}
                    <strong>{item.heading}</strong>
                    {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>
        <div id="list-data_two">
          <div className=" d-flex flex-column mt-1 ">
            {/* heading */}
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "32px",
                letterSpacing: "0.08px",
                textAlign: "start",
                fontFamily: "'Archivo', sans-serif",
                color: "#1F1F1F",
                fontWeight: 700,
              }}
            >
              {stepOneData[0].headingTwo}
            </Typography>
          </div>
          <div id="list_data_content" className=" d-flex flex-column mt-2">
            <ol style={paragraphStyleOL}>
              {stepOneData[0].infoListTwo &&
                stepOneData[0].infoListTwo.map((item, index) => (
                  <li className="mt-2">
                    {" "}
                    <strong>{item.heading}</strong>
                    {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>

        {/* disclaimer */}

        <div className="need_help_container pb-4 pt-3">
          <div
            style={{ border: "1px solid #8A8A8A" }}
            className="w-100 border-start-0 border-end-0 "
          >
            <div
              className="needhelp_box py-3 d-flex justify-content-between w-100"
              onClick={toggleVisibility}
            >
              <Typography
                sx={{
                  width: "100%",
                  fontSize: 16,
                  fontWeight: 700,
                  lineHeight: "24px",
                  fontFamily: "'Archivo', sans-serif",
                  cursor: "pointer",
                }}
              >
                {disclaimerData[0].disclaimer}
              </Typography>
              <Typography className="w-25 text-end" sx={{ cursor: "pointer" }}>
                <FontAwesomeIcon
                  icon={isVisible ? faChevronUp : faChevronDown}
                />
              </Typography>
            </div>

            {/* Conditional rendering of the text */}
            {isVisible &&
              disclaimerData.map((item) => (
                <div
                  key={item.id}
                  className=" faq_container d-flex border-start-0 border-end-0 "
                >
                  <div className="w-100">
                    <div className="information_box no-scrollbar mt-3 ">
                      {/* Hidden text paras */}
                      {item.information.map((info, index) => (
                        <React.Fragment key={index}>
                          <Typography
                            sx={{
                              fontFamily: "'Archivo', sans-serif",
                              fontSize: "16px",
                              lineHeight: "24px",
                              letterSpacing: "normal",
                              textAlign: "start",
                              padding: "0.5rem",
                            }}
                          >
                            {info.infotext}
                          </Typography>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="mt-2">
          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "32px",
              letterSpacing: "0.08px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepOneData[0].headingThree}
          </Typography>
          <Typography
            className="mt-2 mb-4"
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              letterSpacing: "0.08px",
              color: "#1f1f1f",
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            {stepOneData[0].headThreeInfo}
          </Typography>
        </div>
        <div className="tips mt-3">
          <div id="border_line"></div>
          <div id="tip__container" className="px-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex gap-2 align-items-center">
                <img
                  src={tongueOut}
                  alt="minemiTip-img"
                  style={{ width: 30, height: 30 }}
                />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1f1f1f",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {stepOneData[0].minemiTip}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div id="list-data_two">
          <div className=" d-flex flex-column mt-4 ">
            {/* heading */}
            <Typography
              sx={{
                fontSize: "24px",
                lineHeight: "32px",
                letterSpacing: "0.08px",
                textAlign: "start",
                fontFamily: "'Archivo', sans-serif",
                color: "#1F1F1F",
                fontWeight: 700,
              }}
            >
              {stepOneData[0].headingfour}
            </Typography>
          </div>
          <div className="mt-2">
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                color: "#1f1f1f",
                fontFamily: "'Archivo', sans-serif",
              }}
            >
              {stepOneData[0].headfourInfo}
            </Typography>
          </div>
          <div id="list_data_content" className=" d-flex flex-column mt-2">
            <ol style={paragraphStyleOL}>
              {stepOneData[0].infoListfour &&
                stepOneData[0].infoListfour.map((item, index) => (
                  <li className="mt-2">
                    {" "}
                    <strong>{item.heading}</strong>
                    {item.description}
                  </li>
                ))}
            </ol>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepOne;
